<template>
  <div v-if="visible" class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-box" :class="{ 'modal-box--dos-cols': suscEur.length > 0 && suscUsd.length > 0 }">
      <div class="q-modal-header">
        <span class="q-modal-title">{{ titulo }}</span>
        <button class="modal-close" @click="$emit('close')">✕</button>
      </div>

      <div v-if="loading" class="modal-loading">Cargando...</div>
      <div v-else-if="!suscripciones.length" class="modal-empty">Sin suscripciones activas.</div>

      <div v-else class="modal-body">

        <!-- Pestañas EUR/USD — solo visibles en móvil cuando hay ambas monedas -->
        <div v-if="suscEur.length > 0 && suscUsd.length > 0" class="tabs-moneda">
          <button :class="['tab-mon', tabMoneda === 'eur' && 'tab-mon--active tab-mon--eur']" @click="tabMoneda = 'eur'">
            € EUR &nbsp;<span class="tab-total">{{ suscEur.length }} susc. · {{ fmt(totalEur) }}</span>
          </button>
          <button :class="['tab-mon', tabMoneda === 'usd' && 'tab-mon--active tab-mon--usd']" @click="tabMoneda = 'usd'">
            $ USD &nbsp;<span class="tab-total">{{ suscUsd.length }} susc. · {{ fmtUsd(totalUsd) }}</span>
          </button>
        </div>

        <div class="columnas" :class="['columnas--tab-' + tabMoneda, { 'columnas--dos': suscEur.length > 0 && suscUsd.length > 0 }]">

          <!-- Columna EUR -->
          <div v-if="suscEur.length > 0" class="col-moneda col-eur">
            <div class="col-moneda-header">
              <span class="moneda-badge moneda-badge--eur">€ EUR</span>
              <span class="moneda-info">{{ suscEur.length }} suscritor{{ suscEur.length !== 1 ? 'es' : '' }}</span>
              <span class="moneda-total">{{ fmt(totalEur) }} próx.</span>
            </div>
            <div class="tabla-wrap">
              <table class="tabla-ventas">
                <thead>
                  <tr>
                    <th>Vence</th>
                    <th>Cliente</th>
                    <th>Producto</th>
                    <th class="text-right">Próx. cobro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="s in suscEur" :key="s.suscripcion_id" :class="urgencia(s.periodo_fin)">
                    <td class="td-fecha">
                      <span :class="['vence-badge', urgencia(s.periodo_fin)]">{{ fmtFecha(s.periodo_fin) }}</span>
                      <div class="dias-restantes">{{ diasRestantes(s.periodo_fin) }}</div>
                    </td>
                    <td class="td-cliente">
                      <div class="cliente-nombre">{{ s.usuario_nombre }}</div>
                      <div class="cliente-email">{{ s.usuario_email }}</div>
                    </td>
                    <td class="td-producto">{{ s.producto }}</td>
                    <td class="td-importe">
                      <span class="importe-eur">{{ fmt(s.precio) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Columna USD -->
          <div v-if="suscUsd.length > 0" class="col-moneda col-usd">
            <div class="col-moneda-header col-moneda-header--usd">
              <span class="moneda-badge moneda-badge--usd">$ USD</span>
              <span class="moneda-info">{{ suscUsd.length }} suscritor{{ suscUsd.length !== 1 ? 'es' : '' }}</span>
              <span class="moneda-total moneda-total--usd">{{ fmtUsd(totalUsd) }} próx.</span>
            </div>
            <div class="tabla-wrap">
              <table class="tabla-ventas">
                <thead>
                  <tr>
                    <th>Vence</th>
                    <th>Cliente</th>
                    <th>Producto</th>
                    <th class="text-right">Próx. cobro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="s in suscUsd" :key="s.suscripcion_id" :class="urgencia(s.periodo_fin)">
                    <td class="td-fecha">
                      <span :class="['vence-badge', urgencia(s.periodo_fin)]">{{ fmtFecha(s.periodo_fin) }}</span>
                      <div class="dias-restantes">{{ diasRestantes(s.periodo_fin) }}</div>
                    </td>
                    <td class="td-cliente">
                      <div class="cliente-nombre">{{ s.usuario_nombre }}</div>
                      <div class="cliente-email">{{ s.usuario_email }}</div>
                    </td>
                    <td class="td-producto">{{ s.producto }}</td>
                    <td class="td-importe">
                      <span class="importe-usd">{{ fmtUsd(s.precio) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import panelesService from "@/services/paneles.service";

export default {
  name: "ModalRenovacionesActivas",
  props: {
    visible:   { type: Boolean, default: false },
    tipsterId: { type: [Number, String], default: null },
    canAdmin:  { type: Boolean, default: false },
    titulo:    { type: String, default: "Renovaciones activas" },
    dateFrom:  { type: String, default: null },
    dateTo:    { type: String, default: null },
  },
  emits: ["close"],
  data() {
    return { loading: false, suscripciones: [], tabMoneda: 'eur' };
  },
  computed: {
    suscEur()  { return this.suscripciones.filter(s => s.moneda !== 'USD'); },
    suscUsd()  { return this.suscripciones.filter(s => s.moneda === 'USD'); },
    totalEur() { return this.suscEur.reduce((sum, s) => sum + parseFloat(s.precio || 0), 0); },
    totalUsd() { return this.suscUsd.reduce((sum, s) => sum + parseFloat(s.precio || 0), 0); },
  },
  watch: {
    visible(val) { if (val) this.cargar(); },
  },
  methods: {
    async cargar() {
      this.loading = true;
      this.suscripciones = [];
      this.tabMoneda = 'eur';
      try {
        const params = {};
        if (this.dateFrom) params.date_from = this.dateFrom;
        if (this.dateTo)   params.date_to   = this.dateTo;
        let res;
        if (this.canAdmin && this.tipsterId) {
          res = await panelesService.renovacionesActivasAdmin(this.tipsterId, params);
        } else {
          res = await panelesService.renovacionesActivas(params);
        }
        this.suscripciones = res?.data ?? [];
      } catch {
        this.suscripciones = [];
      } finally {
        this.loading = false;
      }
    },
    fmt(n)    { return Number(n || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR" }); },
    fmtUsd(n) { return Number(n || 0).toLocaleString("en-US", { style: "currency", currency: "USD" }); },
    fmtFecha(f) {
      if (!f) return "-";
      return new Date(f).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
    diasRestantes(f) {
      if (!f) return "";
      const dias = Math.ceil((new Date(f) - new Date()) / 86400000);
      if (dias <= 0) return "Vence hoy";
      return `${dias} día${dias !== 1 ? 's' : ''}`;
    },
    urgencia(f) {
      const dias = Math.ceil((new Date(f) - new Date()) / 86400000);
      if (dias <= 1) return "urgente";
      if (dias <= 3) return "pronto";
      return "";
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,.55);
  z-index: 1050; display: flex; align-items: center;
  justify-content: center; padding: 16px;
}
.modal-box {
  background: var(--q-card); border: 1px solid var(--q-border);
  border-radius: 16px; width: 100%; max-width: 720px;
  max-height: 85vh; display: flex; flex-direction: column; overflow: hidden;
  transition: max-width .2s;
}
.modal-box--dos-cols { max-width: 1100px; }

.q-modal-header {
  display: flex; align-items: center; gap: 10px;
  padding: 16px 20px; border-bottom: 1px solid var(--q-border); flex-shrink: 0;
}
.q-modal-title { font-size: 15px; font-weight: 700; flex: 1; color: #d4af37; }
.modal-close { background: none; border: none; cursor: pointer; font-size: 16px; opacity: .5; padding: 4px 6px; color: var(--q-text); }
.modal-close:hover { opacity: 1; }
.modal-loading, .modal-empty { padding: 40px 20px; text-align: center; opacity: .6; font-size: 14px; }
.modal-body { overflow-y: auto; flex: 1; display: flex; flex-direction: column; }

/* Layout dos columnas */
.columnas { display: flex; flex-direction: column; flex: 1; }
.columnas--dos { flex-direction: row; }

.col-moneda { display: flex; flex-direction: column; flex: 1; min-width: 0; }
.columnas--dos .col-eur { border-right: 1px solid var(--q-border); }

/* Cabecera de columna */
.col-moneda-header {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 16px; background: rgba(128,128,128,.04);
  border-bottom: 1px solid var(--q-border); flex-shrink: 0;
}
.moneda-badge {
  font-size: 12px; font-weight: 700; letter-spacing: .05em;
  padding: 3px 10px; border-radius: 20px; flex-shrink: 0;
}
.moneda-badge--eur { background: rgba(212,175,55,.15); color: #d4af37; }
.moneda-badge--usd { background: rgba(38,198,218,.15); color: #26c6da; }
.moneda-info  { font-size: 12px; opacity: .6; flex: 1; }
.moneda-total { font-size: 13px; font-weight: 700; color: #d4af37; font-variant-numeric: tabular-nums; white-space: nowrap; }
.moneda-total--usd { color: #26c6da; }

/* Tabla */
.tabla-wrap { overflow-x: auto; flex: 1; }
.tabla-ventas { width: 100%; border-collapse: collapse; font-size: 13px; }
.tabla-ventas th {
  padding: 10px 14px; text-align: left; font-size: 11px; font-weight: 600;
  text-transform: uppercase; letter-spacing: .04em; opacity: .55;
  border-bottom: 1px solid var(--q-border); white-space: nowrap;
}
.tabla-ventas td { padding: 9px 14px; border-bottom: 1px solid var(--q-border); vertical-align: middle; }
.tabla-ventas tbody tr:last-child td { border-bottom: none; }
.tabla-ventas tbody tr:hover { background: rgba(128,128,128,.05); }
.tabla-ventas tbody tr.urgente td { background: rgba(239,83,80,.06); }
.tabla-ventas tbody tr.pronto  td { background: rgba(255,193,7,.05); }

.td-fecha { white-space: nowrap; }
.vence-badge { font-size: 12px; font-weight: 600; }
tr.urgente .vence-badge { color: #ef5350; }
tr.pronto  .vence-badge { color: #ffc107; }
.dias-restantes { font-size: 11px; opacity: .55; margin-top: 2px; }

.cliente-nombre { font-weight: 600; font-size: 13px; }
.cliente-email  { font-size: 11px; opacity: .55; }
.td-producto { max-width: 160px; font-size: 12px; }
.td-importe  { text-align: right; white-space: nowrap; }
.text-right  { text-align: right; }

.importe-eur { color: #ffc107; font-weight: 700; font-variant-numeric: tabular-nums; }
.importe-usd { color: #26c6da; font-weight: 700; font-variant-numeric: tabular-nums; }

/* Pestañas EUR/USD — ocultas por defecto, visibles solo en móvil */
.tabs-moneda { display: none; }

/* En móvil vuelve a una columna + activa pestañas */
@media (max-width: 700px) {
  .columnas--dos { flex-direction: column; }
  .modal-box--dos-cols { max-width: 100%; }
  .columnas--dos .col-eur { border-right: none; border-bottom: none; }

  .tabs-moneda {
    display: flex;
    border-bottom: 1px solid var(--q-border);
    flex-shrink: 0;
  }
  .tab-mon {
    flex: 1;
    padding: 10px 8px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    font-size: 13px;
    font-weight: 600;
    color: var(--q-muted, #888);
    cursor: pointer;
  }
  .tab-mon--eur.tab-mon--active { border-bottom-color: #d4af37; color: #d4af37; }
  .tab-mon--usd.tab-mon--active { border-bottom-color: #26c6da; color: #26c6da; }

  .tab-total { font-size: 11px; opacity: .75; }

  .columnas--tab-eur .col-usd { display: none; }
  .columnas--tab-usd .col-eur { display: none; }
}
</style>
